// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fdcca070","455":"6e2c695c","488":"ec6a353b"}[chunkId] + ".chunk.js";
};